import { inject } from '@angular/core';
import { times } from '@sama/micro-dash';
import { SensorRendererState } from '../../cross-team-shared/state/sensor-renderer-state';
import { AssetBoundingBox } from '../../team-apis/3d/task-data/asset-bounding-box';
import {
  LoadTaskResult,
  VideoContentConnector as VideoContentConnectorInterface,
} from '../../team-apis/content/content-connector';
import { AbstractContentConnector2D } from '../shared/abstract-content-connector-2d';
import { VideoContentStateUndoService } from './state/video-content-state-undo.service';
import { VideoAssetInitializationService } from './utils/loading/video-asset-initialization.service';

export class VideoContentConnector
  extends AbstractContentConnector2D
  implements VideoContentConnectorInterface
{
  protected assetInitializationService = inject(
    VideoAssetInitializationService,
  );
  protected undoService = inject(VideoContentStateUndoService);

  initForOrthographicTask(
    result: LoadTaskResult,
    assetBoundingBox: AssetBoundingBox,
  ) {
    const sensorFrames = times(result.frameCount, () => ({ imageUrl: '' }));
    const sensorRendererState = new SensorRendererState(
      sensorFrames,
      result.height,
      result.width,
      // Use [0,0] so 2D/3D coordinate systems are initialized with same origin
      [0, 0],
    );

    this.store('sensorRendererState').set(sensorRendererState);
    this.viewBoxService.initializeViewBox([
      assetBoundingBox.min[0],
      // Negate Y coordinate since 3D +Y direction is the opposite of SVG's
      // Then 2D shapes are not affected by the 3D coordinate system
      -assetBoundingBox.max[1],
      result.width,
      result.height,
    ]);
  }

  canRedo() {
    return true;
  }

  canUndo() {
    return true;
  }
}
